import { render, staticRenderFns } from "./DeclaracaoVinculoGrid.vue?vue&type=template&id=381b8738&"
import script from "./DeclaracaoVinculoGrid.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoVinculoGrid.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoVinculoGrid.vue?vue&type=style&index=0&id=381b8738&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports